import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { ProductsService } from 'src/app/services/products.service';

@Component({
  selector: 'app-products-table',
  templateUrl: './products-table.component.html',
  styleUrls: ['./products-table.component.css']
})
export class ProductsTableComponent implements OnInit {

  public products: [];
  public productsEmpty: boolean = false;

  constructor(private productsService: ProductsService, private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.productsService.getProductsAsAdmin().subscribe(result => {
      this.productsEmpty = false;
      this.products = result.data;
    }, error => {
      this.productsEmpty = true;
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    })
  }
}
